import { render } from "./Ad1.vue?vue&type=template&id=16405d43&scoped=true"
import script from "./Ad1.vue?vue&type=script&lang=js"
export * from "./Ad1.vue?vue&type=script&lang=js"

import "./Ad1.vue?vue&type=style&index=0&id=16405d43&scoped=true&lang=css"

import exportComponent from "D:\\wcb\\www\\clpga_htmlgit\\f_pc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16405d43"]])

export default __exports__